module.exports = __webpack_public_path__ + "assets/pro-licence.cefd6b38.svg";